// extracted by mini-css-extract-plugin
module.exports = {"vehicleAvatar":"VehicleImage_vehicleAvatar__1TQMT","engineIcon":"VehicleImage_engineIcon__2bIz0"};